module.exports = __webpack_public_path__ + "assets/svg/Icons/32/location-gray-807497.svg";